<template>
  <div>
    <v-dialog
        v-model="dialogShow"
        width="500"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Edit Item
        </v-card-title>

        <v-card-text class="pt-2">

          <div class="mb-2">
            <p class="text-14 mb-1">Name</p>
            <v-text-field
                v-model="purchasableEdit.name"
                outlined
                dense
                hide-details
            ></v-text-field>
          </div>

          <div>
            <p class="text-14 mb-1">Description</p>
            <v-textarea
                v-model="purchasableEdit.description"
                outlined
                dense
                hide-details
            ></v-textarea>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="primary"
              text
              @click="dialogShow = false"
          >
            Cancel
          </v-btn>

          <v-btn
              color="primary"
              text
              @click="submitHandle"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import backendCall from "@/lib/backendCall";

export default {
  name: "PurchasableInfoEditDialog",
  props: {
    purchasable: Object,
    onCloseDialogHandle: Function
  },
  watch: {
    dialogShow(value){
      console.log("dialog show value: ", value)
      if (value === false) {
        this.onCloseDialogHandle()
      }
    }
  },
  mounted() {
    this.purchasableEdit = Object.assign({}, this.purchasable)
  },
  data() {
    return {
      dialogShow: true,
      purchasableEdit: null
    }
  },
  methods: {
    async submitHandle() {
      const purchasableInfo = {
        purchasableId: this.purchasable.purchasableId,
        name: this.purchasableEdit.name,
        description: this.purchasableEdit.description
      }
      const res = await backendCall.purchasable.updatePurchasableInfo(purchasableInfo)
      if (res.status === 1) {
        Vue.notify(
            {type: "success", text: `${res.message}`}
        )
        this.dialogShow = false
      } else if (res.status === 0) {
        Vue.notify(
            {type: "error", text: `${res.message}`}
        )
      }
    }
  }
}
</script>

<style scoped>

</style>